module.exports = __webpack_public_path__ + "img/paytm_long.cdee236a.svg";